export const generateLotNo = (enquiryNo, userId) => {
    const enqNo = enquiryNo.split('/');
    const posCode =
        userId && userId != '' && userId !== 0 ? userId : getUniqueCode(5, true);
    const randomCode = getUniqueCode(5, false);
    return enqNo[2] + enqNo[3] + 'S' + posCode + 'S' + randomCode;
};
export const getUniqueCode = (length, isAlpha) => {
    return isAlpha
        ? Math.random().toString(36).toUpperCase().slice(-length)
        : new Date().getTime().toString().slice(-length);
};